import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";

const POSummaryDropdown = ({ row }) => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    const handleToggle = () => {
        if (!isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setPosition({
                top: rect.bottom + 10,
                left: rect.right - 120,
            });
        }
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                buttonRef.current &&
                menuRef.current &&
                !buttonRef.current.contains(event.target) &&
                !menuRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        const handleScroll = (event) => {
            // Only close if scroll happens outside the dropdown menu
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            window.addEventListener("scroll", handleScroll, true);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, [isOpen]);

    return (
        <div className="dropdown">
            <button
                type="button"
                className="link dropdown-toggle"
                aria-expanded="false"
                onClick={handleToggle}
                ref={buttonRef}
                title="PO Summary"
            >
                <em class="icon ni ni-info"></em>
            </button>
            {isOpen &&
                createPortal(
                    <ul
                        className="position-fixed dropdown-menu dropdown-menu-end show"
                        style={{
                            maxHeight: "200px",
                            // maxWidth: "100px",
                            top: `${position.top}px`,
                            left: `${position.left}px`,
                            overflowY: "auto",
                        }}
                        ref={menuRef}
                    >
                        <li style={{ cursor: "pointer" }}>
                            <div className="dropdown-item">
                                Ordered Quantity - {row?.po_ordered_qty}
                            </div>
                            <div className="dropdown-item">
                                Pending Quantity - {row?.po_pending_qty}
                            </div>
                            <div className="dropdown-item">
                                Received Quantity - {row?.po_received_qty}
                            </div>
                        </li>
                    </ul>,
                    document.body
                )}
        </div>
    );
};

export default POSummaryDropdown;
